<template>
    <activation-brief-affiliate-links-provider v-slot="{ affiliateLinks, isLoading, handleSubmit, canCreateDeepLink }">
        <activation-brief-affiliate-links-view
            :affiliate-links="affiliateLinks"
            :is-loading="isLoading"
            :can-create-deep-link="canCreateDeepLink"
            @create-deep-link="handleSubmit"
        />
    </activation-brief-affiliate-links-provider>
</template>

<script>
    import ActivationBriefAffiliateLinksView from '../../components/data-views/activation-briefs/ActivationBriefAffiliateLinksView.vue';
    import ActivationBriefAffiliateLinksProvider from '../providers/ActivationBriefAffiliateLinksProvider.vue';

    export default {
        name: 'ActivationBriefAffiliateLinksRouterView',
        components: {
            ActivationBriefAffiliateLinksView,
            ActivationBriefAffiliateLinksProvider
        }
    };
</script>

<style scoped lang="scss"></style>
